import { UserApi } from './user.api';
import { EntryApi } from './entry.api';
import { PlaceApi } from './place.api';
import { IdCardApi } from './idCard.api';
import { TokenDto, LoginDto } from '@/model/user.dto';
import { EntryDto, EntrySearchDto } from '@/model/entry.dto';
import { PlaceDto, PlaceSearchDto } from '@/model/place.dto';
import { IdCardDto, IdCardSearchDto } from '@/model/idCard.dto';

export class ApiService {
  private userApi: UserApi;
  private entryApi: EntryApi;
  private placeApi: PlaceApi;
  private idCardApi: IdCardApi;

  constructor() {
    this.userApi = new UserApi();
    this.entryApi = new EntryApi();
    this.placeApi = new PlaceApi();
    this.idCardApi = new IdCardApi();
  }

  // 유저
  public async getNewToken(refreshToken: string) {
    return await this.userApi.getNewToken(refreshToken);
  }
  public async getMyInfor(accessToken: string) {
    return await this.userApi.getMyInfor(accessToken);
  }

  public async postLogin(dto: LoginDto) {
    return await this.userApi.postLogin(dto);
  }

  // 출입관리
  public async getEntryNum(accessToken: string, dto: EntrySearchDto) {
    return await this.entryApi.getEntryNum(accessToken, dto);
  }
  public async getEntryList(accessToken: string, dto: EntrySearchDto) {
    return await this.entryApi.getEntryList(accessToken, dto);
  }
  public async getEntryDetailList(accessToken: string, dto: EntrySearchDto) {
    return await this.entryApi.getEntryDetailList(accessToken, dto);
  }

  // 출입장소
  public async getPlaceCheck(accessToken: string, name: string) {
    return await this.placeApi.getPlaceCheck(accessToken, name);
  }
  public async getPlaceList(accessToken: string, dto?: PlaceSearchDto) {
    return await this.placeApi.getPlaceList(accessToken, dto);
  }
  public async getFilterPlaceList(accessToken: string, dto: PlaceSearchDto) {
    return await this.placeApi.getFilterPlaceList(accessToken, dto);
  }

  public async postPlaceAdd(accessToken: string, dto: PlaceDto) {
    return await this.placeApi.postPlaceAdd(accessToken, dto);
  }

  public async putPlaceModify(accessToken: string, id: number, dto: PlaceDto) {
    return await this.placeApi.putPlaceModify(accessToken, id, dto);
  }

  public async delPlaceList(accessToken: string, ids: number[]) {
    return await this.placeApi.delPlaceList(accessToken, ids);
  }

  // 출입신분증
  public async getIdCardCheck(accessToken: string, phone: string) {
    return await this.idCardApi.getIdCardCheck(accessToken, phone);
  }
  public async getIdCardList(accessToken: string, dto: IdCardSearchDto) {
    return await this.idCardApi.getIdCardList(accessToken, dto);
  }
  public async getFilterIdCardList(accessToken: string, dto: IdCardSearchDto) {
    return await this.idCardApi.getFilterIdCardList(accessToken, dto);
  }

  public async postIdCardAdd(accessToken: string, dto: IdCardDto) {
    return await this.idCardApi.postIdCardAdd(accessToken, dto);
  }

  public async putIdCardModify(
    accessToken: string,
    id: number,
    dto: IdCardDto,
  ) {
    return await this.idCardApi.putIdCardModify(accessToken, id, dto);
  }

  public async delIdCardList(accessToken: string, ids: number[]) {
    return await this.idCardApi.delIdCardList(accessToken, ids);
  }
}
